
import { defineComponent } from 'vue';
import authStore from '@/shared/auth/auth.store';

export default defineComponent({
    name: 'LogoutLink',
    setup() {
        const logout = (): void => {
            authStore.userLogout();
        };

        return {
            logout,
        };
    },
});
